/**
 * @module core/storage/actions
 */

import { NAMESPACE, STORAGE_SET, STORAGE_UPDATE } from './consts';

/**
 * Salva um valor no subsistema de armazenamento genérico `storage`.
 * Função análoga ao método `Immutable.Map.setIn`.
 *
 * @param {String} view `id` da `view` onde será armazenado o valor.
 * @param {Array} keyPath caminho onde será armazenado o valor.
 * @param {any} value valor a ser armazenado.
 * @returns {Object} uma ação do `Redux`.
 */
function set(view, keyPath, value) {
  return {
    namespace: NAMESPACE,
    type: STORAGE_SET,
    view,
    keyPath,
    value,
  };
}

// TODO remover o notFoundValue
/**
 * Modifica um valor salvo no subsistema de armazenamento genérico `storage`.
 * Função análoga ao método `Immutable.Map.updateIn`.
 *
 * @param {String} view `id` da `view` onde está armazenado o valor.
 * @param {Array} keyPath caminho onde está armazenado o valor.
 * @param {any} notFoundValue @deprecated
 * @param {Function} updater função de atualização.
 * @returns {Object} uma ação do `Redux`.
 */
function update(view, keyPath, notFound, updater) {
  return {
    namespace: NAMESPACE,
    type: STORAGE_UPDATE,
    view,
    notFound: updater ? notFound : null,
    keyPath,
    updater: updater || notFound,
  };
}

const actions = {
  set,
  update,
};

export default actions;
